module.exports = __webpack_public_path__ + "img/map-marker-normal.58b29231.svg";